import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M3,5H29a1,1,0,0,0,0-2H3A1,1,0,0,0,3,5Z"/><path d="M6.79,11a1,1,0,1,0,0,2H25.21a1,1,0,0,0,0-2Z"/><path d="M29,19H3a1,1,0,0,0,0,2H29a1,1,0,0,0,0-2Z"/><path d="M22,27H10a1,1,0,0,0,0,2H22a1,1,0,0,0,0-2Z"/>';
export var TextCenterAlignedOutlineSVG = function TextCenterAlignedOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
TextCenterAlignedOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TextCenterAlignedOutlineSVG);